import VerificationForm from 'components/form/user/VerificationForm';
import React from 'react';

export default function Verification() {
  return <VerificationForm />;
}
